module.exports = __webpack_public_path__ + "static/media/tarjetas.4faa2cf0.svg";